import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-browser-compatablity',
  templateUrl: './browser-compatablity.component.html',
  styleUrls: ['./browser-compatablity.component.scss']
})
export class BrowserCompatablityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
